"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filter(input, chars, invert) {
    if (invert === void 0) { invert = false; }
    if (input == undefined)
        return input;
    var regEx = new RegExp("[" + (invert ? "^" : "") + chars + "]", "g");
    return input.replace(regEx, "");
}
exports.filter = filter;
function filterCharSet(input, invert) {
    var charsets = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        charsets[_i - 2] = arguments[_i];
    }
    var charset = charsets.reduce(function (previousValue, currentValue) {
        return previousValue + currentValue();
    }, "");
    return filter(input, charset, invert);
}
exports.filterCharSet = filterCharSet;
exports.NumberChars = function () {
    return "0-9";
};
exports.EnglishChars = function () {
    return "a-zA-Z";
};
exports.ArabicChars = function () {
    return "\\u0600-\\u06ff";
};
exports.SpaceChars = function () {
    return "\\s";
};
exports.PunctuationsChars = function () {
    return ".,\\/#!$%\\^&\\*;:{}=\\-_`~()";
};
//# sourceMappingURL=RegExFilter.js.map